import { SelectOption } from '../components/Select';

export default function selectOptionValuesAsString<T>(
    options: Array<SelectOption<T>>,
): string {
    return options.map((item) => item.value).join(',');
}
